const link = {
  test: {
    orderCreate:
      'https://store.wps.com/us/test/kpay/center-srv/kpaycenter/api/order/create'
  },
  online: {
    orderCreate:
      'https://store.wps.com/us/default/kpay/center-srv/kpaycenter/api/order/create'
  }
}
export default link.online



// WEBPACK FOOTER //
// ./src/modules/christmasPC-2019/plugins/link.js